// extracted by mini-css-extract-plugin
export var displayFont = "display-font-module--display-font--N6tUF";
export var displayFontAlt = "display-font-module--display-font-alt--lbxcl";